import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

const DropdownForm = ({
  orderFormFieldKey,
  orderFormFieldTouched,
  orderFormFieldError,
  nameText,
  value,
  options,
  handleChange,
  handleBlur,
}) => {
  return (
    <Box
      key={orderFormFieldKey}
      sx={{
        marginTop: "20px",
        width: "100%",
      }}
    >
      <FormControl
        sx={{ width: "250px", marginTop: "20px" }}
        error={Boolean(orderFormFieldTouched && orderFormFieldError)}
      >
        <InputLabel id={`${orderFormFieldKey}-label`}>{nameText}</InputLabel>
        <Select
          required
          labelId={`${orderFormFieldKey}-label`}
          id={orderFormFieldKey}
          name={orderFormFieldKey}
          label={nameText}
          value={value}
          onBlur={handleBlur}
          onChange={handleChange}
        >
          {(options || []).map(({ key, name }, index) => {
            return (
              <MenuItem
                key={key || `option-${index}`}
                value={key || `option-${index}`}
              >
                {name || ""}
              </MenuItem>
            );
          })}
        </Select>
        <FormHelperText>
          {orderFormFieldTouched && orderFormFieldError
            ? orderFormFieldError
            : " "}
        </FormHelperText>
      </FormControl>
    </Box>
  );
};

export default DropdownForm;
